// extracted by mini-css-extract-plugin
export default {"FaQs":"FAQs_FaQs__CcX1J","question":"FAQs_question__dsKsN","answer":"FAQs_answer__wjmqf"};